export default __webpack_public_path__ + "static/media/VER.a4cf6aea.svg";